import { useState, useEffect, useCallback, useRef } from "react"

import Grid from '@material-ui/core/Grid'

import Dialog from "@base/Dialog";
import { ButtonSave } from "@base/Button/ButtonForm"

import Toast from '@base/Toast'
import SelectOption from '@base/Inputs/Select/Select'
import EscolaService from "@services/EscolaService"

export const AtualizarStatusDialog = (props) => {
	const toastRef = useRef(null);
	const [status, setStatus] = useState("");
	const [listagemStatus, setListagemStatus] = useState([]);

	const submit = () => {
		let obj = { id: props.id, status: status};
		EscolaService.atualizarStatusCartao(props.processo,props.escola,props.id,obj).then(ret => {
			props.aoSalvar();
			toastRef.current.show("success","Status do Cartão alterado com sucesso!");
			limparFormulario();
		}).catch(error => {
			toastRef.current.show("error", "Ocorreu um Problema ao alterar o status do Cartão:" + error.response.data.mensagens.map(mensagem => mensagem).join(" ,"));
		});
	}

	const limparFormulario = () => {
		setStatus("");
		setListagemStatus([]);
	}

	const fecharDialog = () => {
		limparFormulario();
		props.aoFechar();
	}

	const carregarDados = useCallback(() => {
		if (props.aberto) {
			setListagemStatus([{ label: "Cortado", value: "CORTADO" },{ label: "Classificado", value: "CLASSIFICADO" },{ label: "Descartado", value: "DESCARTADO" }]);
			setStatus(props.statusAtual);
		}
	}, [props.aberto,props.statusAtual]);

	useEffect(() => carregarDados(), [carregarDados]);

	return (
		<>
			<Toast ref={toastRef} />
			<Dialog
				maxWidth={"sm"}
				fullWidth={true}
				closeDialog={fecharDialog}
				openDialog={props.aberto}
				title="Atualizar Status do Cartão"
				actions={<ButtonSave onClick={submit} />}>

				<Grid container spacing={12}>
					<Grid item sm={9}>
						<SelectOption
							label='Status do Cartão'
							value={status}
							name='status'
							onChange={(e) => setStatus(e.target.value)}
							options={listagemStatus}
						/>
					</Grid>
				</Grid>
			</Dialog>
		</>
	);
}

export default AtualizarStatusDialog;
